import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TaskCard } from '../TaskCard/TaskCard';
import type { Task, TaskType } from '../../../../types';

interface DraggableTaskProps {
  task: Task;
  taskType?: TaskType;
  isCompact?: boolean;
}

export const DraggableTask: React.FC<DraggableTaskProps> = ({
  task,
  taskType,
  isCompact = false
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: task.id,
    data: {
      task,
      type: 'task',
      status: task.status,
      priority: task.priority
    },
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition: isDragging ? 'none' : 'transform 80ms cubic-bezier(0.25, 0.8, 0.25, 1)', // 更快的回弹动画
    zIndex: isDragging ? 1000 : 'auto',
    opacity: isDragging ? 0.3 : 1, // 拖拽时保持一定可见度，提供更好的视觉连续性
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={`
        ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}
        transition-all duration-200 ease-out
      `}
    >
      <TaskCard 
        task={task} 
        taskType={taskType}
        isCompact={isCompact}
      />
    </div>
  );
};